import { AdminAppState, AdminModalsState } from '../../state';

export const getAdminModals = (state: AdminAppState): AdminModalsState =>
  state.modals;
